import { ICommand } from 'core-ts-types';

interface IConfirmAccountStateParams extends ng.ui.IStateParamsService {
  confirmationCode: string;
}

export class ConfirmAccountController {
  constructor(
    $state: ng.ui.IStateService,
    $stateParams: IConfirmAccountStateParams,
    log: any,
    confirmAccountCommand: ICommand
  ) {
    confirmAccountCommand($stateParams.confirmationCode)
      .then(() => {
        log.user.success({
          content: 'Your profile has been confirmed. Welcome back!',
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        return $state.go('my.transfer.credits');
      })
      .catch((data) => {
        var email = '';
        if (!_.isUndefined(data.auto_login)) {
          log.user.success({
            content: 'Your profile has been confirmed. Log in to continue.',
            dismissOnTimeout: false,
            dismissButton: true
          });
          email = data.email;
        }
        $state.go('landing', { user_name: email });
      });
  }
}

angular.module('capability-ng-user-app').controller('ngConfirmAccountController', ConfirmAccountController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/confirm_account/confirm_account.ts